import { render, staticRenderFns } from "./AffiliatePromoteIndex.vue?vue&type=template&id=522cbdcf&"
import script from "./AffiliatePromoteIndex.vue?vue&type=script&lang=js&"
export * from "./AffiliatePromoteIndex.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePromoteIndex.vue?vue&type=style&index=0&id=522cbdcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports